<template>
  <div class="w-full text-center md:absolute md:bottom-5 md:w-full mt-4 md:mt-0">
    <HeaderLogo />
    <StartButton class="mx-auto md:mx-0" />
    <p class="text-xl md:text-5xl mt-4 md:mt-6">
      Building your bets with friends for best value across brands
    </p>
  </div>
</template>

<script setup lang="ts">
import StartButton from '@/components/button/StartButton.vue'
import HeaderLogo from '@/components/header/HeaderLogo.vue'
</script>
